import { cn } from "@/utils/twMerge";

export default function Badge({
  colors = "primary",
  title = "badge",
  last = false,
  first = false,
}) {
  return (
    <div
      className={cn(
        first
          ? "rounded-br-none rounded-tl-none rounded-tr-lg rounded-bl-lg"
          : last
          ? "rounded-bl-lg"
          : `rounded-br-none rounded-tl-none rounded-tr-lg`,
        `px-2 py-1 bg-${colors}GON-400 `
      )}>
      <p className='p2-regular capitalize text-shadesGON-50 '>{title}</p>
    </div>
  );
}
